import { Stack } from "@/core/components/ui/stack";
import { CollapsibleGroup } from "@/accounts-payable/common";
import type { ApAgentAction } from "@/accounts-payable/types";
import { ActionChecklistRow } from "./action-checklist-row";

/** A collapsible group of action rows — Needs review and Resolved share it. */
export const ActionGroup = ({
  label,
  actions,
  defaultOpen,
}: {
  label: string;
  actions: ApAgentAction[];
  defaultOpen: boolean;
}) => (
  <CollapsibleGroup
    label={label}
    count={actions.length}
    defaultOpen={defaultOpen}
  >
    <Stack gap="none" fullWidth>
      {actions.map((a, i) => (
        <ActionChecklistRow key={a.id} action={a} showDivider={i > 0} />
      ))}
    </Stack>
  </CollapsibleGroup>
);
